import { render, staticRenderFns } from "./goods-magnifier-zoom.vue?vue&type=template&id=4b191506&scoped=true"
import script from "./goods-magnifier-zoom.vue?vue&type=script&lang=js"
export * from "./goods-magnifier-zoom.vue?vue&type=script&lang=js"
import style0 from "./goods-magnifier-zoom.vue?vue&type=style&index=0&id=4b191506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b191506",
  null
  
)

export default component.exports